import { STATE } from "../../classes/Enum";
import DeferredImage from "./DeferredImage";
import { CDN_BASE_URL } from "../../helper/image";

const OrderBigItemImageComponent = ({ item }) => {
  if ([STATE.CARD, STATE.SLAB, STATE.SINGLE].includes(item.type)) {
    return (
      <DeferredImage
        className="order-big-image"
        src={`${CDN_BASE_URL}/imgs/${item.base_image_url}-low.png`}
      />
    );
  }

  return (
    <DeferredImage
      className="order-big-image"
      src={`${CDN_BASE_URL}/products/${item.name}.PNG`}
    />
  );
};

export default OrderBigItemImageComponent;
